import {StyleSheet} from 'aphrodite';

const styles = StyleSheet.create({
    textArea: {
        maxWidth: '100%'
    }
});

export default styles;
